import React from "react";
import { TabPanel } from "react-tabs";
import MarketOverview from "../../components/market-overview";
import TabComponent from "../../components/tabs";
import { tabDataOverview } from "../../modules/data";
import {
  doughnutPersonalCareMarket,
  doughnutPersonalCareOptions,
} from "../../components/demo-doughnut/options";
import PersonalCareIM from "../../components/horizontal-bar-chart/personal-care/PersonalCareIM";
import PersonalCareTM from "../../components/horizontal-bar-chart/personal-care/PersonalCareTM";
import BabyCareIM from "../../components/horizontal-bar-chart/baby/BabyCareIM";
import BabyCareTM from "../../components/horizontal-bar-chart/baby/BabyCareTM";
import HealthCareIM from "../../components/horizontal-bar-chart/healthcare/HealthCareIM";
import HealthCareTM from "../../components/horizontal-bar-chart/healthcare/HealthCareTM";
import HouseholdIM from "../../components/horizontal-bar-chart/household/HouseholdIM";
import HouseholdTM from "../../components/horizontal-bar-chart/household/HouseholdTM";
import "./demo.css";
import PetCareIM from "../../components/horizontal-bar-chart/pet-care/PetCareIM";
import PetCareTM from "../../components/horizontal-bar-chart/pet-care/PetCareTM";

const Demo = () => {
  return (
    <section className='demo'>
      <div className='demo-charts-demo'>
        <TabComponent data={tabDataOverview}>
          <TabPanel>
            <MarketOverview
              donutIndenpendentMarketOpt={doughnutPersonalCareOptions}
              donutTotalMarketOpt={doughnutPersonalCareMarket}
            />
          </TabPanel>
          {/* Personal Care */}
          <TabPanel className='tab-panel'>
            <div className='hbc-container'>
              <p className='market-heading' id='margin-bottom'>
                Independents Market Value <br />
                <span className='market-values'> £98.5m (+8.0%)</span>
              </p>
              <PersonalCareIM />
            </div>
            <div className='hbc-container'>
              <p className='market-heading' id='margin-bottom'>
                Total Market Value <br />
                <span className='market-values'> £4.61bn (+8.1%)</span>
              </p>
              <PersonalCareTM />
            </div>
          </TabPanel>
          {/* Baby */}
          <TabPanel className='tab-panel'>
            <div className='hbc-container'>
              <p className='market-heading' id='margin-bottom'>
                Independents Market Value <br />
                <span className='market-values'> £39.6m (+5.2%)</span>
              </p>
              <BabyCareIM />
            </div>
            <div className='hbc-container'>
              <p className='market-heading' id='margin-bottom'>
                Total Market Value <br />
                <span className='market-values'> £1.30bn (+4.0%)</span>
              </p>
              <BabyCareTM />
            </div>
          </TabPanel>
          {/* Healthcare */}
          <TabPanel className='tab-panel'>
            <div className='hbc-container'>
              <p className='market-heading' id='margin-bottom'>
                Independents Market Value <br />
                <span className='market-values'> £122.7m (+9.4%)</span>
              </p>
              <HealthCareIM />
            </div>
            <div className='hbc-container'>
              <p className='market-heading' id='margin-bottom'>
                Total Market Value <br />
                <span className='market-values'> £2.07bn (+7.7%)</span>
              </p>
              <HealthCareTM />
            </div>
          </TabPanel>
          {/* Household */}
          <TabPanel className='tab-panel'>
            <div className='hbc-container'>
              <p className='market-heading' id='margin-bottom'>
                Independents Market Value <br />
                <span className='market-values'> £119.7m (+4.1%)</span>
              </p>
              <HouseholdIM />
            </div>
            <div className='hbc-container'>
              <p className='market-heading' id='margin-bottom'>
                Total Market Value <br />
                <span className='market-values'> £3.39m (+6.7%)</span>
              </p>
              <HouseholdTM />
            </div>
          </TabPanel>
          {/* Pet Food */}
          <TabPanel className='tab-panel'>
            <div className='hbc-container'>
              <p className='market-heading' id='margin-bottom'>
                Independents Market Value <br />
                <span className='market-values'> £231.9m (+14.5%)</span>
              </p>
              <PetCareIM />
            </div>
            <div className='hbc-container'>
              <p className='market-heading' id='margin-bottom'>
                Total Market Value <br />
                <span className='market-values'> £2.87bn (+11.2%)</span>
              </p>
              <PetCareTM />
            </div>
          </TabPanel>
        </TabComponent>
      </div>
    </section>
  );
};

export default Demo;
